export enum EnumMasterBenefitInsuranceType {
  "custom" = "custom",
  "package" = "package",
  "none" = "none",
}
